import { connect } from 'react-redux';
import { getString } from 'app/api/redux-watson/watson-config-selectors';
import { replaceParams, replaceParamsSingularPlural } from 'app/utils/strings';
import UnsafeHtml from 'app/ui/core/common/UnsafeHtml';
import React from 'react';
import { noticeError } from 'app/api/analytics/reporting';
import PropTypes from 'prop-types';

function LocaleString({ id, value, params = {}, unsafeHtml, noSpan, count }) {
  function getInnerContent() {
    let content = value;
    if (count !== undefined) {
      params = { count, ...params };

      content = replaceParamsSingularPlural(value[1], value[2], params, count);
    } else if (params) {
      content = replaceParams(value, params);
    }

    if (!content) {
      noticeError(`Missing message: ${id}`);
      return '';
    }

    if (unsafeHtml) {
      return <UnsafeHtml>{content}</UnsafeHtml>;
    }
    return content;
  }

  const content = getInnerContent();

  if (noSpan || typeof content !== 'string') {
    return getInnerContent();
  }
  return <span data-msg-id={id}>{content}</span>;
}

LocaleString.propTypes = {
  id: PropTypes.string.isRequired,
  unsafeHtml: PropTypes.bool,
  noSpan: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => ({
  value: getString(state, ownProps.id),
});

export default connect(mapStateToProps)(LocaleString);

export const LocaleStringTest = LocaleString;
